import {
  Component,
  OnInit,
} from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import { MatDatepickerInputEvent } from "@angular/material";
import * as moment from "moment";
import { FormControl } from "@angular/forms";

@Component({
  selector: 'app-op-events',
  templateUrl: './op-events.component.html',
  styleUrls: ['./op-events.component.scss']
})
export class OpEventsComponent implements OnInit {
  public userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  ProviderId: string = "SportRadar";
  sportsList = [];
  showAlert: boolean = false;
  eventsList = [];
  filteredevents = [];
  searchKey = "";
  sportId;
  sportName: string = ""
  start: any;
  end: any;
  sportSettings: any = {};
  selectedSport = new FormControl([]);
  selected: any = {
    startDate: null,

    endDate: null,
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

  eventsTableColumns = [
    "Open Date",
    "Event Id",
    "Competition Id",
    "Event Name",
    "Competition Name"
  ];
  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.getSportsByProvider(this.ProviderId);
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.selected.startDate = moment(
      new Date(new Date().setDate(new Date().getDate() - 4))
    );
    this.selected.endDate = moment(
      new Date(new Date().setDate(new Date().getDate() + 3))
    );
    this.activetedRoute.queryParams.subscribe((params) => {
      this.sportId = params["sportId"];
      this.sportName = params["sportName"];
      this.start = params["startDate"];
      this.end = params["endDate"];
    });
    if (this.start !== undefined && this.end !== undefined) {
      this.selected.startDate = moment(parseInt(this.start))
      this.selected.endDate = moment(parseInt(this.end))
    }
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment(
          new Date(new Date().setDate(new Date().getDate() - 4))
        );
        this.selected.endDate = moment(
          new Date(new Date().setDate(new Date().getDate() + 3))
        );
        setTimeout(() => {
          this.showAlert = false;
        }, 3000);
      }
    }
  };

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sportsList = res.sports;
          if(this.sportId) {
            const index = this.sportsList.findIndex(sport => sport.SportId === this.sportId);
            this.selectedSport.setValue([this.sportsList[index]]);
            this.getSettlementEvents();
          }
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  searchHandlerChange() {
    if (this.searchKey.length >= 1) {
      this.eventsList = this.filteredevents.filter((event) => {
        if (
          event.eventName
            .toLocaleLowerCase()
            .includes(this.searchKey.toLocaleLowerCase())
        ) {
          return event;
        }
      });
    } else {
      this.eventsList = this.filteredevents;
    }
  }

  getSettlementEvents() {
    try {
      let filters = {
        providerId : this.ProviderId,
        sportId : this.selectedSport.value.length != 0 ?this.selectedSport.value[0].SportId : "",
        startDate : Number(
          (this.selected.startDate.valueOf() / 1000).toString().split(".")[0]
        ),
        endDate : Number(
          (this.selected.endDate.valueOf() / 1000).toString().split(".")[0]
        )
      }
      this.appService
        .getEventsForOP(filters)
        .subscribe((response) => {
          this.eventsList = response.events
          this.filteredevents = response.events
                  });
    } catch (err) {
      console.log(err);
    }
  }

  goToMarketsPage(event) {
    this.router.navigate(["surveillance/markets"], {
      queryParams: {
        providerId: event.providerId,
        sportId: event.sportId,
        eventId: event.eventId,
        eventName: event.eventName,
        sportName: event.sportName,
        openDate: event.openDate,
        startDate: this.selected.startDate,
        endDate: this.selected.endDate,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }
}
